import { Box, Checkbox, Flex, Text } from "@chakra-ui/react";
import moment from "moment-timezone";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import apiClient from "../../utils/ApiClient/apiClientAxios";
// import { demoSearchPersonResult } from "../../utils/demoData";
import SearchPersonForm from "./SearchPersonForm";
import SearchPersonResultTable from "./SearchPersonResultTable";

const PERSIST_KEY = "personPersistedSearch";
const SearchPerson = ({ onClose }) => {
  const [searchResult, setSearchResult] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [persistSearch, setPersistSearch] = useState(false);
  const { register, handleSubmit, setValue, watch, reset } = useForm();
  const navigate = useNavigate();
  const previousDataRef = useRef(null);
  // Load persisted search on mount
  useEffect(() => {
    const persisted = JSON.parse(localStorage.getItem(PERSIST_KEY));
    if (persisted?.data && persisted?.result) {
      reset(persisted.data);
      setSearchResult(persisted.result);
      setPersistSearch(true);
      previousDataRef.current = persisted.data;
    }
  }, [reset]);

  const onSubmit = async (data) => {
    const formattedData = JSON.parse(JSON.stringify(data));
    const formatDates = (obj) => {
      for (const key in obj) {
        if (obj[key] && typeof obj[key] === "object") {
          formatDates(obj[key]);
        } else if (
          key.toUpperCase().includes("DATE") &&
          typeof obj[key] === "string" &&
          moment(obj[key], "YYYY-MM-DD", true).isValid()
        ) {
          obj[key] = moment(obj[key]).format("YYYYMMDD");
        }
      }
    };

    formatDates(formattedData);
    if (
      JSON.stringify(formattedData) === JSON.stringify(previousDataRef.current)
    ) {
      console.log("Data has not changed. Skipping API call.", formattedData);
      return;
    }

    try {
      setIsLoading(true);
      const response = await apiClient.post("/searchPerson", formattedData);
      const result = response.data;
      setSearchResult(result);
      previousDataRef.current = formattedData;
      if (persistSearch) {
        localStorage.setItem(
          PERSIST_KEY,
          JSON.stringify({ data: formattedData, result }),
        );
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePersistToggle = (e) => {
    const checked = e.target.checked;
    setPersistSearch(checked);
    if (!checked) {
      localStorage.removeItem(PERSIST_KEY);
    }
  };

  const handleOpenCase = (PersonID) => {
    navigate(`/personview/${PersonID}`);
    onClose();
  };

  return (
    <Box minH="70vh">
      <Flex>
        <Box w="30%" borderRight="2px solid gray" pr={4}>
          <SearchPersonForm
            handleSubmit={handleSubmit}
            onSubmit={onSubmit}
            register={register}
            isLoading={isLoading}
            setValue={setValue}
            watch={watch}
          />
          <Checkbox
            mt={2}
            isChecked={persistSearch}
            onChange={handlePersistToggle}
          >
            Persist Search
          </Checkbox>
        </Box>

        <Box w="70%" pl={2}>
          {searchResult?.length > 0 && !isLoading ? (
            <SearchPersonResultTable
              handleOpenCase={handleOpenCase}
              searchResult={searchResult}
              isLoading={isLoading}
            />
          ) : (
            <Text textAlign="center" fontSize="xl" my={5}>
              No record found
            </Text>
          )}
        </Box>
      </Flex>
    </Box>
  );
};

export default SearchPerson;
